export default class HeroOverlay {
  constructor() {
    this.init();
  }

  init() {
    const items = $('.hero-img-overlay');

    items.each((index, element) => {
      element.style.setProperty('--opacity', element.dataset.overlayOpacity);
    });
  }
}
